import { render, staticRenderFns } from "./ChangeDomainModal.vue?vue&type=template&id=8e12fb26"
import script from "./ChangeDomainModal.vue?vue&type=script&lang=js"
export * from "./ChangeDomainModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports